import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

// Routes imports
import createBrowserHistory from "history/createBrowserHistory";
import { Router } from "react-router-dom";
const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js